import React from "react";
import { FaDownload } from "react-icons/fa";
import { MdKeyboard } from "react-icons/md";
import "./HeroSection.css";
import header from "../../assets/phoneimage.PNG";

const HeroSection = () => {
  return (
    <div className="crypto-wallet-container">
      <div className="crypto-wallet-content">
        <h1 className="crypto-wallet-title">
          Your secure crypto wallet to explore blockchain
        </h1>
        <p className="crypto-wallet-description">
          Easy and safe to buy, store, send, swap tokens and collect NFTs.
          Trusted by 25+ millions users from 200+ countries and regions.
        </p>
        <div className="crypto-wallet-buttons">
          <button className="download-button">
            <FaDownload /> Download
          </button>
          <button className="keypal-button">
            <MdKeyboard /> KeyPal
          </button>
        </div>
      </div>
      <div className="crypto-wallet-images">
        <img src={header} alt="crypto" className="browser-view-image" />
      </div>
    </div>
  );
};

export default HeroSection;
